import { createSlice } from "@reduxjs/toolkit";

const DEFAULT = {
  insideEducation: true,
  gradeCode: undefined,
  educationStatusCode: undefined,
  universityTypeCode: undefined,
  universityName: "",
  educationGroupCode: undefined,
  field: "",
  seminaryLevelCode: undefined,
  seminarySchoolName: "",
  turbansStatusCode: undefined,
  educationType: "1",
};

const initialState = {
  isNew: true,
  isDataChanged: false,
  reloadPage: false,
  data: [DEFAULT],
};

export const EducationInformationSlice = createSlice({
  name: "educationInformation",
  initialState,
  reducers: {
    updateEducationInformationData: (state, { payload: { index, key, value, required } }) => {
      state.data[index][key] = value;
      state.isDataChanged = true;
      if (value.length === 0) {
        if (required) {
          state.data[index][key] = value;
        } else {
          delete state.data[index][key];
        }
      } else {
        state.data[index][key] = value;
      }
    },
    setIsDataChangedForEducation: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForEducationInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setEducationInformationData: (state, { payload }) => {
      state.isDataChanged = false;
      state.data = payload;
      state.data.forEach((item, i) => {
        if (!item.educationType) {
          state.data[i].educationType = "1";
        }
      });
    },
    addEducationInformationData: (state) => {
      state.isDataChanged = true;
      state.data.push({ ...DEFAULT, educationType: "1" });
    },
    removeEducationInformationData: (state, { payload: index }) => {
      state.isDataChanged = true;
      state.data.splice(index, 1);
    },
    clearEducationInformationData: () => initialState,
    setReloadEducationInformationData: (state, { payload }) => {
      state.reloadPage = payload;
    },
  },
});
export const {
  updateEducationInformationData,
  setIsNewForEducationInformation,
  setEducationInformationData,
  addEducationInformationData,
  removeEducationInformationData,
  setIsDataChangedForEducation,
  clearEducationInformationData,
  setReloadEducationInformationData,
} = EducationInformationSlice.actions;
export const EducationInformationReducer = EducationInformationSlice.reducer;
